export default __webpack_public_path__ + "static/media/or.cbbd2a5a.jpg";